import { render } from "./AddAlloyFortigate.vue?vue&type=template&id=6fb97665"
import script from "./AddAlloyFortigate.vue?vue&type=script&lang=js"
export * from "./AddAlloyFortigate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__